angular.module('assets')
    .component('assetDocumentShow', {
        bindings: {
            item: '<?'
        },
        templateUrl: 'app/asset/document/show.html',
        controller: function ($scope, $state, $window, AssetService){
            this.AssetService = AssetService;

            this.cancel = () => $window.history.back();

            $scope.$on('asset-doc.updated', () => $state.reload());
        }
    })
